import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BonusHistoryList } from '@my-account/const';

@Component({
  selector: 'sd-bonus-history-block',
  templateUrl: './bonus-history-block.component.html',
  styleUrls: ['./bonus-history-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, DatePipe],
})
export class BonusHistoryBlockComponent {
  @Input() bonuses: BonusHistoryList[];

  constructor() {}
}
